// extracted by mini-css-extract-plugin
export default {"container":"icon-component_container__KrIBj","truncate-table":"icon-component_truncate-table__7PeTQ","table-text-faded":"icon-component_table-text-faded__76Jxw","icon-svg":"icon-component_icon-svg__CBu+X","icon-svg--outline":"icon-component_icon-svg--outline__oyI6H","icon-svg--stroke-width":"icon-component_icon-svg--stroke-width__JKxwg","icon-svg--filled":"icon-component_icon-svg--filled__9iHae"};
    if(module.hot) {
      // 1793877082240
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  